export default __webpack_public_path__ + "static/media/cup.a08955d6.png";